"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Switch.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Switch = function Switch(_ref) {
  var disabled = _ref.disabled,
      checked = _ref.checked,
      onChange = _ref.onChange;

  var changeHandler = function changeHandler(_ref2) {
    var target = _ref2.target;
    onChange(target.checked);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "switch-container"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "switch"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    onChange: changeHandler,
    disabled: disabled,
    checked: checked
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "slider round"
  })));
};

Switch.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool
};
Switch.defaultProps = {
  onChange: function onChange() {
    return console.warn('no function was assigned as prop');
  },
  disabled: false,
  checked: false
};
var _default = Switch;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Switch/Switch.js
// module id = 1925
// module chunks = 0